import { render, staticRenderFns } from "./DifficultDropdown.vue?vue&type=template&id=6b96e007&"
import script from "./DifficultDropdown.vue?vue&type=script&lang=ts&"
export * from "./DifficultDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports